var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCloseNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.0001 18.3334C14.6025 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 5.39771 14.6025 1.66675 10.0001 1.66675C5.39771 1.66675 1.66675 5.39771 1.66675 10.0001C1.66675 14.6025 5.39771 18.3334 10.0001 18.3334Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8834 10L12.8 8.08338C13.0417 7.84172 13.0417 7.44172 12.8 7.20005C12.5584 6.95838 12.1584 6.95838 11.9167 7.20005L10 9.11671L8.08338 7.20005C7.84172 6.95838 7.44172 6.95838 7.20005 7.20005C6.95838 7.44172 6.95838 7.84172 7.20005 8.08338L9.11671 10L7.20005 11.9167C6.95838 12.1584 6.95838 12.5584 7.20005 12.8C7.32505 12.925 7.48338 12.9834 7.64172 12.9834C7.80005 12.9834 7.95838 12.925 8.08338 12.8L10 10.8834L11.9167 12.8C12.0417 12.925 12.2 12.9834 12.3584 12.9834C12.5167 12.9834 12.675 12.925 12.8 12.8C13.0417 12.5584 13.0417 12.1584 12.8 11.9167L10.8834 10Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloseNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-close-notification.a28d82bbf33753be80297d0abc4613d5.svg";